import type { ISearchProduct } from '@/types';
import type { HomeListContext } from '@/lib/gtm';
import dynamic from 'next/dynamic';

// ssr:true (default) so home shelf HTML from getStaticProps still emits product anchors.
const Helium = dynamic(() => import('@/components/products/cards/helium'));
const Neon = dynamic(() => import('@/components/products/cards/neon')); // grocery-two
const Argon = dynamic(() => import('@/components/products/cards/argon')); // bakery
const Krypton = dynamic(
  () => import('@/components/products/cards/krypton'), // furniture extra price
);
const Xenon = dynamic(() => import('@/components/products/cards/xenon')); // furniture-two
const Radon = dynamic(() => import('@/components/products/cards/radon')); // Book

const MAP_PRODUCT_TO_CARD: Record<string, any> = {
  neon: Neon,
  helium: Helium,
  argon: Argon,
  krypton: Krypton,
  xenon: Xenon,
  radon: Radon,
};
interface ProductCardProps {
  product: ISearchProduct;
  className?: string;
  cardType?: any;
  listContext?: HomeListContext;
  imagePriority?: boolean;
}
const ProductCard: React.FC<ProductCardProps> = ({
  product,
  className,
  listContext,
  imagePriority,
  ...props
}) => {
  const Component = product?.type?.settings?.productCard
    ? MAP_PRODUCT_TO_CARD[product?.type?.settings?.productCard]
    : Helium;
  return (
    <Component
      product={product}
      listContext={listContext}
      {...(imagePriority && Component === Helium && { imagePriority })}
      {...props}
      className={className}
    />
  );
};
export default ProductCard;
